type TableDataProps = {
  children: React.ReactNode;
};

const TableData = ({ children }: TableDataProps) => (
  <td className="w-1/2 px-6 py-4 text-sm">{children}</td>
);

export { TableData };
